var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuvDefault = function SvgSuvDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.127 14.889a1.222 1.222 0 1 1-2.444 0 1.222 1.222 0 0 1 2.444 0ZM37.36 14.889a1.222 1.222 0 1 1-2.444 0 1.222 1.222 0 0 1 2.444 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M23.63 3.563h-.04a.4.4 0 0 0-.351.595l1.566 2.678a.77.77 0 0 0 .667.384c1.928 0 4.165 0 6.056.003.364.001.523-.453.231-.672-3.907-2.934-6.247-2.964-8.128-2.988ZM14.97 4.618l-1.435 2.246a.78.78 0 0 1-.661.358c-1.57-.01-2.764.027-3.592.061-.588.024-.875-.533-.385-.858 1.37-.91 3.76-1.515 5.803-2.158.209-.066.389.166.27.351ZM21.138 3.615c-1.173-.051-2.97-.016-3.997.232a.69.69 0 0 0-.419.317L15.21 6.636a.387.387 0 0 0 .33.588l7.315-.003c.294 0 .48-.314.34-.572l-1.432-2.638a.75.75 0 0 0-.624-.396Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m8.868 14.888-3.396-.742a.54.54 0 0 1-.42-.443l-.07-.42a4.12 4.12 0 0 1 .382-2.507v0a.4.4 0 0 0 .041-.223l-.26-2.769a.71.71 0 0 1 .226-.604c1.139-1.013 3.814-2.697 8.1-4.275a1 1 0 0 1 .114-.032c4.809-.954 9.75-.99 14.39-.013a.8.8 0 0 1 .216.082c2.392 1.345 4.403 2.785 6.28 3.74q.124.063.263.079c.732.087 4.273.558 7.566 1.871.096.039.176.1.213.197.241.635.82 3.242-.275 5.282a.7.7 0 0 1-.512.353l-2.5.424m-24.286 0h18.214"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.906,
    cy: 14.889,
    r: 2.857,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M38.996 14.889a2.857 2.857 0 1 1-5.715 0 2.857 2.857 0 0 1 5.715 0Z"
  })));
};
export default SvgSuvDefault;